/*
 * @Description:
 * @Author: mdb
 * @Date: 2023-04-21 10:50:12
 * @LastEditTime: 2023-04-21 10:59:41
 * @LastEditors: mdb
 */
export const paramCodesEnum = {
  fbu: {
    product: 'zbu_product_type_fbu', // 产品货型
    channel: 'zbu_channel_detail_fbu', // 销售平台
    demand: 'zbu_demand_info_fbu', // 需求海外仓
    monthly: 'zbu_monthly_sales_fbu', // 跨境月销售额
    service: 'zbu_service_demand_fbu', // 服务需求
    category: 'zbu_sales_category_fbu', // 销售品类
    customerCategory: 'zbu_customer_category_fbu', // 客户类别
    shipments: 'ofbu_shipments',
    businessTypeSelect: 'ofbu_business_type',
    salesChannel: 'ofbu_sales_channel',
    clientType: 'ofbu_client_type',
    clueChannel: 'ofbu_source_channel',
    regionalWarehouse: 'ofbu_demand_info'
  },
  lbu: {
    product: 'zbu_product_type_lbu', // 产品货型
    channel: 'zbu_channel_detail_lbu', // 销售平台
    demand: 'zbu_demand_info_lbu', // 需求海外仓
    monthly: 'zbu_monthly_sales_lbu', // 跨境月销售额
    service: 'zbu_service_demand_lbu', // 服务需求
    category: 'zbu_sales_category_lbu', // 销售品类
    customerCategory: '',
    shipments: 'ofbu_shipments',
    businessTypeSelect: 'ofbu_business_type',
    salesChannel: 'ofbu_sales_channel',
    clientType: 'ofbu_client_type',
    clueChannel: 'ofbu_source_channel',
    regionalWarehouse: 'ofbu_demand_info'
  },
  ofbu: {
    product: 'ofbu_product_type', // 产品货型
    channel: 'ofbu_sale_platform', // 销售平台
    demand: '', // 需求海外仓
    monthly: '', // 跨境月销售额
    service: '', // 服务需求
    category: 'ofbu_sales_category', // 销售品类
    customerCategory: '',
    shipments: 'ofbu_shipments',
    businessTypeSelect: 'ofbu_business_type',
    salesChannel: 'ofbu_sales_channel',
    clientType: 'ofbu_client_type',
    clueChannel: 'ofbu_source_channel',
    regionalWarehouse: 'ofbu_demand_info'
  }
}
